import SessionManager from "../Session.manager";
import { User } from "../../classes/User";
import Global from "../../scripts/Global";
import ChannelSessionManager from "./Channels.manager";
import VueSignals from "../../scripts/VueSignals";
import UserApi from "../../scripts/api/user.api";

let UsersDocs = new Array()
let loggedInUser = new User(null)
let BotUser = new User(null)
let isLoggedIn = false

export default class UserSessionManager {
    constructor(){}

    static CreateUser(data){
        let userDoc = new User(data)
        /** Detect if currunt logged in user doesn't have username */
        if(userDoc.user_id == loggedInUser.user_id && userDoc.username == ''){
            Global.globalValue(VueSignals.OVERLAY_TYPE, 'update_profile')
            Global.globalValue(VueSignals.SHOW_MODAL, true)
        }

        if(!UsersDocs.some(currUserDoc => {return currUserDoc.user_id == userDoc.user_id})){
            UsersDocs.push(userDoc)
        }else {
            for(let i=0; i<UsersDocs.length;i++){
                if(UsersDocs[i].user_id == userDoc.user_id){
                    UsersDocs[i] = userDoc
                    break
                }
            }
        }
        SessionManager.UpdateDirectMessageNameWithUserId(userDoc.user_id, userDoc.username)

        return userDoc
    }


    static createUserByID(user_id){
        UserApi.getUsers([user_id]).then(res=> {
            if(res.data.result){
                if(!UsersDocs.some(currUserDoc => {return currUserDoc.user_id == user_id})){
                    UsersDocs.push(new User(res.data.user[0]))
                }
            }
        })
    }

    static SetLoggedInUser(oUserData){
        oUserData.reachability = "online"
        loggedInUser = new User(oUserData)
        for(let i =0; i < UsersDocs.length;i++) {
            if(UsersDocs[i].user_id == loggedInUser.user_id){
                UsersDocs[i] = loggedInUser
                break
            }
        }
        isLoggedIn = true
        Global.globalValue(VueSignals.LOGGED_IN_USER, true)
    }


    static SetUserReachability(user_id, statue){
        for(let i=0; i< UsersDocs.length; i++){
            if(UsersDocs[i].user_id == user_id){
                UsersDocs[i].status_mode = statue
                if(statue != "offline" && statue != "incognito" ){
                    UsersDocs[i].reachability =  "online"
                }else {
                    UsersDocs[i].reachability =  "offline"
                }
                break
            }
        }
    }
    /**
     *  Bot User Data
     */

    static SetBot(data){
        BotUser  = new User(data)
    }

    static GetBot(botId){
        return BotUser
    }

    static SetLoggedinUserFolderRights(rights){
        loggedInUser.folder_rights = rights
    }


    static GetLoggedinUserFolderRights(){
        return loggedInUser.folder_rights
    }


    static UpdateUser(data){
        SessionManager.UpdateDirectMessageReachability(data[0].user_id, data[0].reachability)
        SessionManager.UpdateDirectMessageNameWithUserId(data[0].user_id, data[0].username)
        if(data[0].user_id == loggedInUser.user_id){
            for(let attr in data[0]){
                if(attr != "image_doc" && data[0][attr] != loggedInUser[attr]){
                    loggedInUser[attr] = data[0][attr]
                }

                if(attr == "image_doc" && data[0].image_doc != null && typeof data[0].image_doc.valueb64 != 'undefined'){
                    loggedInUser.image_doc = "data"+data[0].image_doc.mimetype+";base64," + data[0].image_doc.valueb64
                    if(data[0].image_doc.mimetype.indexOf(":")== -1){
                        loggedInUser.image_doc = "data:"+data[0].image_doc.mimetype+";base64," + data[0].image_doc.valueb64
                    }
                    loggedInUser.default_image = false
                }
            }
            Global.globalValue(VueSignals.CHANNEL_USERS_CHANGED, data[0].user_id)
            return
        }
        else if(!UsersDocs.some(currUser => {currUser.user_id == data[0].user_id}) &&
            data[0].user_id != loggedInUser.user_id){
                let newUser = UserSessionManager.CreateUser(data[0])
                Global.globalValue(VueSignals.CHANNEL_USERS_CHANGED, data[0].user_id)
                return
        }else {
            for(let i=0; i < UsersDocs.length;i++){
                if(UsersDocs[i].user_id == data[0].user_id){
                    for(let attr in data[0]){
                        if(attr != "image_doc" && data[0][attr] !=  UsersDocs[i][attr]){
                            UsersDocs[i][attr] = data[0][attr]
                        }
                        if(attr == "image_doc" && data[0].image_doc != null && typeof data[0].image_doc.valueb64 != 'undefined'){
                            UsersDocs[i].image_doc = "data"+data[0].image_doc.mimetype+";base64," + data[0].image_doc.valueb64
                            if(data[0].image_doc.mimetype.indexOf(":")== -1){
                                UsersDocs[i].image_doc = "data:"+data[0].image_doc.mimetype+";base64," + data[0].image_doc.valueb64
                            }
                            UsersDocs[i].default_image = false
                        }
                    }
                    Global.globalValue(VueSignals.CHANNEL_USERS_CHANGED, data[0].user_id)
                    break
                }
            }
        }
    }

    static IsLoggedIn(){
        return isLoggedIn
    }


    static GetOnlineUsers(user_ids){
        if(user_ids.length > 0){
            return UsersDocs.filter(currUser=> {return user_ids.indexOf(currUser.user_id) > -1 && (
                currUser.reachability == "online" || currUser.reachability == "busy"
            )}).sort(function(a,b){
                if(b.reachability == 'online'){
                    return 1
                }
                return -1
            })

        }
    }

    static GetUsers(){
        for(let i=0;i<UsersDocs.length;i++){
            if(UsersDocs[i].username.length == 0){
                UsersDocs[i].username = UsersDocs[i].email
            }
        }

        return UsersDocs.sort(function(a,b){
            if(b.reachability == 'online'){
                return 1
            }
            return -1
        })
    }

    static GetUser(user_id){
        if(user_id == loggedInUser.user_id){
            return loggedInUser
        }
        if(user_id == BotUser.user_id){
            return BotUser
        }

        for(let i = 0; i <UsersDocs.length;i++){
            if(UsersDocs[i].user_id == user_id){
                if(UsersDocs[i].username.length == 0){
                    UsersDocs[i].username = UsersDocs[i].email
                }
                return UsersDocs[i]
            }
        }

        // // Not found in cache
        // let response = await UserApi.getUsers([user_id]);
        // console.log('searching through api', response);
        // if (response.data.result) {
        //     return new User(response.data.user[0]);
        // } else {
        //     return new User()
        // }
            return new User()
    }

    static MakeUserCall(user_id){
        return UserApi.getUsers([user_id]).then(res=> {
            if(res.data.result){
                if(!UsersDocs.some(currUserDoc => {return currUserDoc.user_id == user_id})){
                    UsersDocs.push(new User(res.data.user[0]))
                }
            }
        })
    }

    static GetUserByEmail(user_email){
        for(let i = 0; i <UsersDocs.length;i++){
            if(UsersDocs[i].email == user_email){
                if(UsersDocs[i].username.length == 0){
                    UsersDocs[i].username = UsersDocs[i].email
                }
                return UsersDocs[i]
            }
        }
        return new User()
    }

    static GetLoggedInUserId(){
        return loggedInUser.user_id
    }

    static GetLoggedInUserDoc(){
        return loggedInUser
    }

    static Clear(){
        UsersDocs = []
        isLoggedIn = false
        loggedInUser = new User(null)
    }

    static RemoveLoggedInUser(arr){
        for(let i = 0;i < arr.length; i++){
          if(typeof arr[i] != 'undefined' && arr[i].user_id == UserSessionManager.GetLoggedInUserId()){
            arr.splice(i, 1)
          }
        }
        return arr
      }

    static FilterFromDirectChannel(arr){
        let DirectChannels = ChannelSessionManager.GetDirectChannels()
        for(let i=0; i <arr.length;i++){
            for(let j=0; j<DirectChannels.length;j++){
                if(DirectChannels[j].user_ids.indexOf(arr[i].user_id) > -1){
                    arr.splice(i, 1)
                    break
                }
            }
        }
        return arr
    }
}
